import(/* webpackMode: "eager" */ "/home/ec2-user/videohighlight/highlight-v5.1.23/apps/website/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Header"] */ "/home/ec2-user/videohighlight/highlight-v5.1.23/apps/website/src/components/header.tsx");
;
import(/* webpackMode: "eager" */ "/home/ec2-user/videohighlight/highlight-v5.1.23/node_modules/next/dist/client/script.js");
